<template>
  <div class="flex flex-wrap -mx-2 text-sm items-stretch">
    <div class="flex-1 w-1/2 px-4">
      <h1 slot="header" class="w-full text-lg py-4">
        Account Details
      </h1>
      <div class="w-full pb-6">
        This is the email address you use to log in to the {{system.title}}
      </div>
      <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
        <div class="w-full px-2 mb-4">
          <label class="mr-1">Email Address:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Visit your Ecosystem profile to update this information.</span>
              </div>
            </i>
            <p class="text-sm mt-2">{{ profile_v2.email }}</p>
        </div>
      </div>
    </div>
    <div class="flex-1 w-1/2 px-4">
      <h1 slot="header" class="w-full text-lg py-4">
        Email Settings
      </h1>
      <div class="w-full pb-6">
        Please tick the boxes below to receive the associated ‘system generated reminder emails’, or untick them to opt-out.
      </div>
      <div class="w-1/2 -mx-2 p-2">
        <input type="checkbox" id="reminder_email" v-model="profile_v2.reminder_email">
        <label for="reminder_email">APS Reminder Email</label>
      </div>
      <div class="w-1/2 -mx-2 p-2">
        <input type="checkbox" id="referral_update_emails" v-model="profile_v2.referral_update_emails">
        <label for="referral_update_emails">Referral Update Emails</label>
      </div>
      <div class="w-1/2 -mx-2 p-2" v-if="selectedOffice.automated_referrals_permission === true">
        <input type="checkbox" id="automated_referral_update_emails" v-model="profile_v2.automated_referral_update_emails">
        <label for="automated_referral_update_emails">Automated Referral Update Emails</label>
      </div>
      <div class="w-1/2 -mx-2 p-2 mb-4">
        <input type="checkbox" id="expiring_branded_video_reminder" v-model="profile_v2.expiring_branded_video_reminder">
        <label for="expiring_branded_video_reminder">Expiring Branded Video Reminder Email</label>
      </div>
      <div class="w-1/2 -mx-2 p-2">
        <button class="bg-primary text-white px-8 py-4 text-xs w-5/6 rounded" :class="{'opacity-25': email_settings_button_disabled}" :disabled="email_settings_button_disabled" @click="updateEmailSettings">Update Email Settings</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import api from '@/http'
export default {
  name: 'ProfilePassword',
  props: ['errorBag'],
  computed: {
    ...mapState(['profile_v2', 'selectedOffice', 'system'])
  },
  data () {
    return {
      new_password: '',
      confirmed_password: '',
      password_not_match: false,
      button_disabled: true,
      email_button_disabled: true,
      password_short: false,
      email_before_edit: null,
      email_settings_button_disabled: true,
      expiring_branded_video_reminder_before_edit: null,
      referral_update_emails_before_edit: null,
      automated_referral_update_emails_before_edit: null
    }
  },
  watch: {
    confirmed_password () {
      if (this.confirmed_password === this.new_password) {
        this.password_not_match = false
        this.button_disabled = false
        return
      }
      this.password_not_match = true
      this.button_disabled = true
    },
    new_password () {
      if (this.new_password.length < 8) {
        this.password_short = true
        return
      }
      this.password_short = false
    },
    'profile_v2.email' () {
      if (this.email_before_edit !== this.profile_v2.email) {
        this.email_button_disabled = false
        return
      }
      this.email_button_disabled = true
    },
    'profile_v2.referral_update_emails' () {
      if (this.referral_update_emails_before_edit !== this.profile_v2.referral_update_emails) {
        this.email_settings_button_disabled = false
        return
      }
      this.email_settings_button_disabled = true
    },
    'profile_v2.automated_referral_update_emails' () {
      if (this.automated_referral_update_emails_before_edit !== this.profile_v2.automated_referral_update_emails) {
        this.email_settings_button_disabled = false
        return
      }
      this.email_settings_button_disabled = true
    },
    'profile_v2.reminder_email' () {
      if (this.reminder_email_before_edit !== this.profile_v2.reminder_email) {
        this.email_settings_button_disabled = false
        return
      }
      this.email_settings_button_disabled = true
    },
    'profile_v2.expiring_branded_video_reminder' () {
      if (this.expiring_branded_video_reminder_before_edit !== this.profile_v2.expiring_branded_video_reminder) {
        this.email_settings_button_disabled = false
        return
      }
      this.email_settings_button_disabled = true
    }
  },
  mounted () {
    this.email_before_edit = this.profile_v2.email.slice()
  },
  methods: {
    ...mapActions([
      'displayToastNotification', 'fetchProfileV2'
    ]),
    updateEmailSettings () {
      api.patch('/update-email-settings', this.profile_v2).then(
        response => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Email settings updated',
            info: 'Your email settings have been updated successfully.'
          })
          this.reminder_email_before_edit = this.profile_v2.reminder_email
          this.referral_update_emails_before_edit = this.profile_v2.referral_update_emails
          this.automated_referral_update_emails_before_edit = this.profile_v2.automated_referral_update_emails
          this.expiring_branded_video_reminder_before_edit = this.profile_v2.expiring_branded_video_reminder
          this.email_settings_button_disabled = true
        },
        error => {
          this.errorBag.store(error.response.data)
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'Order',
            info: 'Error saving email.'
          })
          this.email_settings_button_disabled = true
        }
      )
    }
  }
}
</script>

<style scoped>
</style>
